import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

  constructor() {

  }

  user_consult(){
    let st = localStorage.getItem("user");
    if( st !== null ){
      return true;
    }else{
      return false;
    }
  }
  consult_storage( item:any ){
    return localStorage.getItem( item );
  }

  guarda_st( variable:any, valor:any ){
    let ls = localStorage.setItem(variable, valor);
  }
  elimina_st( elimina:any ){
    return localStorage.removeItem(elimina);
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/servicios/storage.service.ts